// AUPRÉA — Écran « Mes disponibilités » (consultant)
import { useState, useEffect } from "react";
import axios from "axios";
import { C, Btn, Input, Alert, Spinner, FormField } from "./shared";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const api = axios.create({ baseURL: BACKEND + "/api" });
api.interceptors.request.use((c) => {
  const tok = localStorage.getItem("auprea_token");
  if (tok) c.headers.Authorization = `Bearer ${tok}`;
  return c;
});

const fmtDate = (iso) => {
  try { return new Date(iso).toLocaleDateString("fr-FR", { weekday: "long", day: "2-digit", month: "short" }); } catch { return iso; }
};

export const Disponibilites = ({ user }) => {
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [date, setDate] = useState("");
  const [heure, setHeure] = useState("");
  const [duree, setDuree] = useState(60);
  const [err, setErr] = useState("");

  const reload = async () => {
    setLoading(true);
    try {
      const r = await api.get("/disponibilites");
      setSlots(r.data);
    } catch (e) { setErr(e?.response?.data?.detail || "Erreur"); }
    finally { setLoading(false); }
  };
  useEffect(() => { reload(); }, []);

  const add = async () => {
    if (!date || !heure) { setErr("Date + heure requises"); return; }
    setErr("");
    try {
      await api.post("/disponibilites", { conseillerId: user.conseiller_id || user.id, date, heure, duree: Number(duree) });
      setDate(""); setHeure("");
      reload();
    } catch (e) { setErr(e?.response?.data?.detail || "Erreur"); }
  };

  const del = async (id) => {
    if (!window.confirm("Supprimer ce créneau ?")) return;
    try { await api.delete(`/disponibilites/${id}`); reload(); }
    catch (e) { setErr(e?.response?.data?.detail || "Erreur"); }
  };

  if (loading) return <Spinner />;

  const libres = slots.filter(s => !s.reserved);
  const reserves = slots.filter(s => s.reserved);

  return (
    <>
      {err && <Alert type="error"><span>⚠</span><span>{err}</span></Alert>}
      <div style={{ background: "#fff", border: `.5px solid ${C.border}`, borderRadius: 12, padding: 20, marginBottom: 20 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: C.navy, marginBottom: 12, fontFamily: "'Playfair Display', serif" }}>Ajouter un créneau</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr auto", gap: 10, alignItems: "end" }}>
          <FormField label="Date"><Input type="date" value={date} onChange={(e) => setDate(e.target.value)} data-testid="dispo-date" /></FormField>
          <FormField label="Heure"><Input type="time" value={heure} onChange={(e) => setHeure(e.target.value)} data-testid="dispo-heure" /></FormField>
          <FormField label="Durée (min)"><Input type="number" value={duree} onChange={(e) => setDuree(e.target.value)} data-testid="dispo-duree" /></FormField>
          <Btn variant="gold" onClick={add} data-testid="dispo-add">+ Ajouter</Btn>
        </div>
      </div>

      <div style={{ fontSize: 11, fontWeight: 700, color: C.muted, textTransform: "uppercase", letterSpacing: ".1em", marginBottom: 10 }}>Créneaux libres ({libres.length})</div>
      {libres.length === 0 ? (
        <div style={{ padding: 30, textAlign: "center", color: C.muted, background: "#fff", borderRadius: 12, border: `.5px solid ${C.border}`, marginBottom: 20 }}>Aucun créneau libre. Ajoutez-en pour permettre à vos clients de réserver après paiement.</div>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 10, marginBottom: 24 }}>
          {libres.map(s => (
            <div key={s.id} style={{ background: "#fff", border: `.5px solid ${C.border}`, borderRadius: 10, padding: 14, borderLeft: `3px solid ${C.teal}` }} data-testid={`dispo-${s.id}`}>
              <div style={{ fontSize: 14, fontWeight: 700, color: C.navy, textTransform: "capitalize" }}>{fmtDate(s.date)}</div>
              <div style={{ fontSize: 12, color: C.mid }}>{s.heure} · {s.duree} min</div>
              <div style={{ marginTop: 8 }}><Btn small variant="red" onClick={() => del(s.id)} data-testid={`dispo-del-${s.id}`}>Suppr.</Btn></div>
            </div>
          ))}
        </div>
      )}

      {reserves.length > 0 && (
        <>
          <div style={{ fontSize: 11, fontWeight: 700, color: C.muted, textTransform: "uppercase", letterSpacing: ".1em", marginBottom: 10 }}>Créneaux réservés ({reserves.length})</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 10 }}>
            {reserves.map(s => (
              <div key={s.id} style={{ background: C.goldlt, border: `.5px solid ${C.gold}`, borderRadius: 10, padding: 14 }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: C.navy, textTransform: "capitalize" }}>{fmtDate(s.date)}</div>
                <div style={{ fontSize: 12, color: C.mid }}>{s.heure} · {s.duree} min</div>
                <div style={{ fontSize: 10, color: C.gold, fontWeight: 700, marginTop: 4, textTransform: "uppercase", letterSpacing: ".05em" }}>Réservé</div>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};
